import { createLucideIcon } from 'lucide-react';

export const ScanBuilding = createLucideIcon('ScanBuilding', [
  // Scan corners
  ['path', { d: 'M3 7V5a2 2 0 0 1 2-2h2', key: 'aa7l1z' }],
  ['path', { d: 'M17 3h2a2 2 0 0 1 2 2v2', key: '4qcy5o' }],
  ['path', { d: 'M21 17v2a2 2 0 0 1-2 2h-2', key: '6vwrx8' }],
  ['path', { d: 'M7 21H5a2 2 0 0 1-2-2v-2', key: 'ioqczr' }],

  // Small building
  [
    'rect',
    {
      width: '10',
      height: '12',
      x: '7',
      y: '6',
      rx: '2',
      ry: '2',
      key: 'rect',
    },
  ],
  ['path', { d: 'M10.1 17v-2h4v2', key: 'door' }],
  ['path', { d: 'M10.1 9h.01', key: 'top-left-window' }],
  ['path', { d: 'M14.2 9h.01', key: 'top-right-window' }],
  ['path', { d: 'M10.1 12h.01', key: 'bottom-left-window' }],
  ['path', { d: 'M14.2 12h.01', key: 'bottom-right-window' }],
]);
